import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {EmailVerificationRoutingModule} from './email-verification-routing.module';
import {EmailVerificationComponent} from './email-verification.component';
import {SharedSoftwareModule} from '@modules/shared/shared-software-module/shared-software.module';


@NgModule({
  declarations: [
    EmailVerificationComponent
  ],
  imports: [
    CommonModule,
    EmailVerificationRoutingModule,
    SharedSoftwareModule,
  ]
})
export class EmailVerificationModule {
}
